/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Chart_Stock_OutInputs */

const vi_report_chart_stock_out = /** @type {(inputs: Report_Chart_Stock_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất kho`)
};

/**

* @param {Report_Chart_Stock_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_chart_stock_out = /** @type {((inputs?: Report_Chart_Stock_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Chart_Stock_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_chart_stock_out(inputs)
});